import type {
  GetListResponseOfSelectOption,
  GetListResponseOfSiteSimpleResponse,
  GetSiteListRequestV2,
  SiteRequest,
  SiteResponse,
} from 'src/api/ProactApiClient';
import {siteApiClient} from 'src/api/ProactApiClientInstances';
import {emptySplitApi} from '../api';
import {clientQuery} from '../clientQuery';

export const siteApi = emptySplitApi.injectEndpoints({
  endpoints: builder => ({
    getSiteSelectOptions: builder.query<
      GetListResponseOfSelectOption,
      GetSiteListRequestV2
    >({
      queryFn: clientQuery(params => siteApiClient.listSelectOptions(params)),
      providesTags: ['Sites'],
    }),
    getSiteListV2: builder.query<
      GetListResponseOfSiteSimpleResponse,
      GetSiteListRequestV2
    >({
      queryFn: clientQuery(params => siteApiClient.listV2(params)),
      providesTags: ['Sites'],
    }),
    getSite: builder.query<SiteResponse, number>({
      queryFn: clientQuery(id => siteApiClient.get(id)),
      providesTags: ['Sites'],
    }),
    createSite: builder.mutation<SiteResponse, SiteRequest>({
      queryFn: clientQuery(request => siteApiClient.create(request)),
      invalidatesTags: ['Sites'],
    }),
    updateSite: builder.mutation<SiteResponse, SiteRequest>({
      queryFn: clientQuery(request => siteApiClient.update(request)),
      invalidatesTags: ['Sites'],
    }),
    deleteSite: builder.mutation<boolean, number>({
      queryFn: clientQuery(id => siteApiClient.delete(id)),
      invalidatesTags: ['Sites'],
    }),
    updateSiteActiveStatus: builder.mutation<
      SiteResponse,
      {id: number; active: boolean}
    >({
      queryFn: clientQuery(({id, active}) =>
        siteApiClient.updateActiveStatus(id, active)
      ),
      invalidatesTags: ['Sites'],
    }),
  }),
});

export const {
  useGetSiteSelectOptionsQuery,
  useGetSiteListV2Query,
  useGetSiteQuery,
  useCreateSiteMutation,
  useUpdateSiteMutation,
  useDeleteSiteMutation,
  useUpdateSiteActiveStatusMutation,
} = siteApi;
